import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSafari = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#safari_svg__a)' rx={9.5} />
    <defs>
      <pattern id='safari_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#safari_svg__b' transform='matrix(.0032 0 0 .0032 -.299 0)' />
      </pattern>
      <image
        xlinkHref='/images/icons/safari-6fb955a4.webp'
        id='safari_svg__b'
        width={500}
        height={313}
      />
    </defs>
  </svg>
);
export default SvgSafari;
